<template>
  <v-app>
    <v-content  class="pt-0">

      <v-card class="mx-auto content-personal" max-width="95%" style="padding:30px; font-size: 14px;" :flat='true'>

        <v-row>
          <v-col cols="12" lg="6" class="pa-2">
          <img
            @click="show_full(1)"
              style="width: 100%;"
                  class="rounded-lg"
                  :src="rsini_1"
                />
          </v-col>

          <v-col cols="12" lg="6" class="pa-2">
            <img
            @click="show_full(2)"
              style="width: 100%;"
                    class="rounded-lg"
                    :src="rsini_2"
                  />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" lg="6" class="pa-2">
          <img
          @click="show_full(3)"
              style="width: 100%;"
                  class="rounded-lg"
                  :src="rsini_3"
                />
          </v-col>

          <v-col cols="12" lg="6" class="pa-2">
            <img
            @click="show_full(4)"
              style="width: 100%;"
                    class="rounded-lg"
                    :src="rsini_4"
                  />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" lg="6" class="pa-2">
          <img
          @click="show_full(5)"
              style="width: 100%;"
                  class="rounded-lg"
                  :src="rsini_5"
                />
          </v-col>

          <v-col cols="12" lg="6" class="pa-2">
            <img
            @click="show_full(6)"
              style="width: 100%;"
                    class="rounded-lg"
                    :src="rsini_6"
                  />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" lg="6" class="pa-2">
          <img
            @click="show_full(7)"
              style="width: 100%;"
                  class="rounded-lg"
                  :src="rsini_7"
                />
          </v-col>
        

          <v-col cols="12" lg="6" class="pa-2" style="min-height: 150px;">
            <div class="rounded-lg" style="width: 100%; height: 98%; background-color: #185ba685; align-items: center;display: flex;justify-content: center;">
              <v-chip
                class="mr-2 ml-2"
                dark
                outlined
                label
                style="margin-bottom:20px; font-style: italic;"
                @click="more_photo()"
                color="white">
                <v-icon left>mdi-image-multiple</v-icon>
                больше фотографий
              </v-chip>

            </div>
          </v-col>
        </v-row>
      </v-card>
    </v-content>


    <v-dialog v-model="registration_dialog" max-width="90%">
      <v-card style="background-color: unset;">
        <!-- <v-card-title class="headline">Записаться на экскурсию
        </v-card-title> -->
        <div v-for="image in images" v-if="image.id == current_photo_id" style="width: 100%;">
          <img
            @click="next_photo()"
            style="width: 100%;"
                :src="image.small_url"
              />
        </div>


        <v-card-actions>
          <v-spacer></v-spacer>
          <v-chip
                class="mr-2 ml-2"
                dark
                outlined
                label
                style="margin-bottom:20px; font-style: italic;"
                @click="registration_dialog = false"
                color="red darken-1">
                <v-icon left>mdi-close</v-icon>
              </v-chip>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-app>
</template>
<script>

import rsini_4 from '../../../src/assets/archive/fsni_1.jpg';
import rsini_5 from '../../../src/assets/archive/fsni_2.jpg';
import rsini_6 from '../../../src/assets/archive/fsni_3.jpg';
import rsini_1 from '../../../src/assets/archive/fsni_4.jpg';
import rsini_2 from '../../../src/assets/archive/fsni_5.jpg';
import rsini_3 from '../../../src/assets/archive/fsni_6.jpg';
import rsini_7 from '../../../src/assets/archive/fsni_7.jpg';

export default {
  name: 'Photo_24',
  data: () => ({
    user_site_reg: false,
    registration_dialog: false,
    rsini_1,
    rsini_2,
    rsini_3,
    rsini_4,
    rsini_5,
    rsini_6,
    rsini_7,
    current_photo_id: 1,
    images: [
      {id: 1, small_url: rsini_1},
      {id: 2, small_url: rsini_2},
      {id: 3, small_url: rsini_3},
      {id: 4, small_url: rsini_4},
      {id: 5, small_url: rsini_5},
      {id: 6, small_url: rsini_6},
      {id: 7, small_url: rsini_7},
    ]
  }),

  mounted() {
  },

  methods: {
    more_photo(){
      console.log('more_photo')
      window.open(`https://disk.yandex.ru/a/qBQwQC8aYxVKEA`)
      window.open(`https://disk.yandex.ru/d/GEPknW3X9_RxvQ`)

    },

    next_photo(){
      var t = this.current_photo_id + 1;
      if(t > 7)
        t = t - 7
        this.current_photo_id = t
    },

    show_full(id){
      this.current_photo_id = id;
      this.registration_dialog = true;
    },
  },
  
};
</script>
<style lang="scss" scoped>
  .content-personal{
    -webkit-box-shadow: 1px 5px 24px 0 rgba(124,77,255,.05);
    box-shadow: 1px 5px 24px 0 rgba(124,77,255,.05);
    border-width: 0;
    -webkit-transition: all .2s;
    transition: all .2s;
    background-color: #fff;
    border-radius: 13px!important;
}
.theme--light.v-application {
    background: rgb(248, 248, 248) !important;
    color: rgba(0, 0, 0, 0.87);
}

.date-interval {
    margin-bottom: 0 !important;
    display: none !important;
}

@media screen and (max-width:767px) {
  .content-personal {
    max-width: 90% !important;
  }
  .content-personal__header {
    flex-direction: column;
  }
}
</style>
